import LedGlow from "@/components/apex/LedGlow";

/**
 * سطح درفة الباب: يقصّ منطقة الباب من الصورة الأصلية ويمدّها
 * على المستطيل المطلوب، مع إطار ومقبض مرسومين عند الحاجة.
 * يستخدم background-position لأنه غير متأثر باتجاه الصفحة (RTL/LTR).
 */
const DoorSurface = ({ design, hingeSide = "start", className = "", showHardware = true }) => {
  const [x0, y0, x1, y1] = design.crop;
  const cw = Math.min(Math.max(x1 - x0, 0.02), 1);
  const ch = Math.min(Math.max(y1 - y0, 0.02), 1);
  const posX = cw >= 0.999 ? 0 : (x0 / (1 - cw)) * 100;
  const posY = ch >= 0.999 ? 0 : (y0 / (1 - ch)) * 100;

  return (
    <div
      className={`relative h-full w-full overflow-hidden ${className}`}
      style={{
        backgroundImage: `url("${design.src}")`,
        backgroundSize: `${(1 / cw) * 100}% ${(1 / ch) * 100}%`,
        backgroundPosition: `${posX}% ${posY}%`,
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* إضاءة وتدرّج لمحاكاة الضوء على السطح */}
      <span
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            hingeSide === "start"
              ? "linear-gradient(90deg, rgba(0,0,0,0.26) 0%, rgba(0,0,0,0.04) 20%, rgba(255,255,255,0.06) 68%, rgba(0,0,0,0.1) 100%)"
              : "linear-gradient(270deg, rgba(0,0,0,0.26) 0%, rgba(0,0,0,0.04) 20%, rgba(255,255,255,0.06) 68%, rgba(0,0,0,0.1) 100%)",
        }}
      />
      <LedGlow led={design.led} crop={design.crop} />

      {design.hardware && showHardware && (
        <>
          <span
            className="pointer-events-none absolute inset-0"
            style={{
              boxShadow:
                "inset 0 0 0 1.5px rgba(255,255,255,0.14), inset 0 0 0 3px rgba(18,28,36,0.55)",
            }}
          />
          <span
            className="pointer-events-none absolute"
            style={{
              top: "26%",
              height: "48%",
              width: "2.2%",
              minWidth: "3px",
              borderRadius: "999px",
              [hingeSide === "start" ? "right" : "left"]: "9%",
              background:
                "linear-gradient(90deg, #8d969d 0%, #e6ebef 40%, #ffffff 52%, #aab3ba 75%, #6d767d 100%)",
              boxShadow: "0 1px 6px rgba(0,0,0,0.5)",
            }}
          />
        </>
      )}
    </div>
  );
};

export default DoorSurface;
